import { render, staticRenderFns } from "./NewVersionModal.vue?vue&type=template&id=39e26b7d&"
import script from "./NewVersionModal.vue?vue&type=script&lang=js&"
export * from "./NewVersionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports